import React from 'react';
import classes from './SocialProfileSelectorListItem.module.scss';
import { UseFormReturn } from 'react-hook-form';

export type SocialProfileSelectorListItemViewProps = {
  socialProfileComponent: JSX.Element;
  useFormInstance: UseFormReturn;
  useFormName: string;
  useFormValue?: string;
  disabled?: boolean;
  callbackToOpenSettingsDropdown?: (checked: boolean) => void;
};

export const SocialProfileSelectorListItemView = (props: SocialProfileSelectorListItemViewProps): JSX.Element => {
  const handleWrapperClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    const { useFormInstance, useFormName, useFormValue, disabled, callbackToOpenSettingsDropdown } = props;
    if (disabled) return;
    const currentValue = useFormInstance?.getValues(useFormName);
    const valueToSet = !currentValue ? useFormValue : false;
    useFormInstance?.setValue(useFormName, valueToSet);
    useFormInstance?.trigger(useFormName);
    if (callbackToOpenSettingsDropdown) {
      callbackToOpenSettingsDropdown(!!valueToSet);
    }
  };

  // TODO Should probably render the whole <SocialProfile> component in here based on props, to avoid duplication.
  return (
    <div className={classes.SocialProfileSelectorListItem} onClick={handleWrapperClick}>
      {props.socialProfileComponent}
    </div>
  );
};
